export enum FundsWriteOffEnum {
  LINEAR = 'LINEAR',
  DEGRESSIVE = 'DEGRESSIVE'
}
